import OfferInterface from 'interfaces/offer.interface';
import { ProductUrlParams } from 'modules/product/interfaces/product-url-params.interface';
import { ProductInterface } from 'modules/product/interfaces/product.interface';

export const FINANCING_MIN_VALUE = 500;
export const FINANCING_MAX_VALUE = 300000;
export const FINANCING_STEP_VALUE = 500;

export const PERIOD_MIN_VALUE = 3;
export const PERIOD_MAX_VALUE = 120;
export const PERIOD_INITIAL_VALUE = 60;

const SECTION_NAME = 'financing';

export const veloDSA = {
    title: 'Reklama',
    advertiserName: 'VeloBank S.A.',
    paidName: 'VeloBank S.A.'
};

export function isFinancingAllowed(productPrice: number): boolean {
    return productPrice >= FINANCING_MIN_VALUE && productPrice <= FINANCING_MAX_VALUE;
}

export function isFinancingWithinBounds(financingPrice: number, financingPeriod: number): boolean {
    return (financingPrice >= FINANCING_MIN_VALUE && financingPrice <= FINANCING_MAX_VALUE)
            && (financingPeriod >= PERIOD_MIN_VALUE && financingPeriod <= PERIOD_MAX_VALUE);
}

export function isFinancingSectionPromoted(productUrlParams: ProductUrlParams): boolean {
    return productUrlParams?.query?.promo_section === SECTION_NAME;
}

export function isShowFinancing(promotedOffer: OfferInterface, product: ProductInterface): boolean {
    return promotedOffer && (product.offers.count > 0) && isFinancingAllowed(promotedOffer.price);
}
